module.exports = __webpack_public_path__ + "static/media/badge_header.9940bf67.svg";